import React from 'react';
import { Helmet } from 'react-helmet';

import Header from './components/Header';
import Apply1 from './components/Apply1';
import Apply2 from './components/Apply2';
import Apply3 from './components/Apply3';
import Footer from './components/Footer';

function Apply() {
  const state = {
    activeTab: {
      home: '',
      aboutUs: '',
      staff: '',
      apply: 'active',
    },
    linkWebsite: '/apply',
  };

  return (
    <>
      <Helmet>
        <title>Aplique-se - Alliance Virtual</title>
      </Helmet>
      <Header activeTab={state.activeTab} linkWebsite={state.linkWebsite} />
      <main>
        <Apply1 />
        <Apply2 />
        <Apply3 />
      </main>
      <Footer />
    </>
  );
}

export default Apply;
